<template>
  <section class="w100">
    <el-carousel :interval="interval"
                 :type="type"
                 :autoplay="autoplay"
                 :direction="direction"
                 :arrow="arrow"
                 :trigger="trigger"
                 :indicator-position="position"
    >
      <el-carousel-item v-for="(data,i) in datas" :key="i">
        <el-image :src="data.filePath"></el-image>
      </el-carousel-item>
    </el-carousel>
  </section>
</template>

<script>

  let list = [];
  export default {
    props: {
      componentData: {
        type: String
      },
      showFlag: {
        type: Array
      }
    },
    name: "eleImages",
    data() {
      return {
        type: '',      //类型
        autoplay: '',  //自动切换
        interval: 3,  //切换时间
        direction: 'horizontal', //显示方向
        arrow: '',     //切换箭头显示时机
        trigger: '',   //指示器触发方式
        position: '',  //指示器显示位置
        datas: [],
        configFlag: false
      }
    },
    watch: {
      showFlag: {
        handler(newVal, oldVal) {
          if (this.configFlag) {
            this.datas = list.filter(x => x.flag.indexOf(newVal) != -1)
          }
        }
      }
    },
    methods: {},
    created() {
      if (this.componentData) {
        let data = JSON.parse(this.componentData);
        if (data) {
          if (data.type) {
            this.type = data.type;
          } else {
            this.type = '';
          }
          this.autoplay = data.autoplay;
          this.interval = parseInt(data.intervalTime + "000");
          this.direction = data.direction;
          this.arrow = data.arrow;
          this.trigger = data.triggerWay;
          this.position = data.position;
          this.configFlag = data.configFlag;

          this.datas = Object.values(JSON.parse(data.params));
          list = Object.values(JSON.parse(data.params))
        }
      }
    },
  }
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/lib/showMoudle/eleImages.vue